/* =============================================================
   google-review-exchange.js — Google Review Exchange page
   Scroll progress, IntersectionObserver reveal, hero stagger, counters
   ============================================================= */
(function () {
  'use strict';

  function initProgress() {
    var bar = document.querySelector('.grx__progress');
    if (!bar) return;
    function update() {
      var doc = document.documentElement;
      var top = doc.scrollTop || document.body.scrollTop;
      var max = (doc.scrollHeight || document.body.scrollHeight) - doc.clientHeight;
      bar.style.width = (max > 0 ? Math.min(100, (top / max) * 100) : 0).toFixed(2) + '%';
    }
    window.addEventListener('scroll', update, { passive: true });
    update();
  }

  function initReveal() {
    var targets = document.querySelectorAll('.grx-reveal');
    if (!targets.length) return;
    if (!('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.1 });
    targets.forEach(function (el) { io.observe(el); });
  }

  function initHeroStagger() {
    var els = document.querySelectorAll('.grx__hero [data-stagger]');
    if (!els.length) return;
    els.forEach(function (el, i) {
      el.style.opacity = '0';
      el.style.transform = 'translateY(14px)';
      el.style.transition = 'opacity 0.5s cubic-bezier(0.16,1,0.3,1), transform 0.5s cubic-bezier(0.16,1,0.3,1)';
      el.style.transitionDelay = (i * 0.1 + 0.1) + 's';
      setTimeout(function () { el.style.opacity = '1'; el.style.transform = 'none'; }, 60);
    });
  }

  function animateCounter(el, target, suffix, duration) {
    suffix = suffix || '';
    duration = duration || 900;
    var start = performance.now();
    function step(now) {
      var p = Math.min((now - start) / duration, 1);
      var eased = p === 1 ? 1 : 1 - Math.pow(2, -10 * p);
      el.textContent = Math.round(eased * target) + suffix;
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function initCounters() {
    var counters = document.querySelectorAll('.grx [data-counter]');
    if (!counters.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        animateCounter(
          el,
          parseInt(el.getAttribute('data-counter'), 10),
          el.getAttribute('data-counter-suffix') || ''
        );
        io.unobserve(el);
      });
    }, { threshold: 0.3 });
    counters.forEach(function (el) { io.observe(el); });
  }

  function relocateForm() {
    var mount = document.getElementById('grx-form-mount');
    if (!mount) return;
    var grx = document.querySelector('.grx');
    var grxSection = grx && grx.closest('.shopify-section');
    if (!grxSection) return;

    var formSection = grxSection.nextElementSibling;
    if (!formSection || formSection === mount) return;
    if (!formSection.querySelector('.pxFormGenerator, iframe[src*="hulkapps"], .shopify-app-block')) {
      return;
    }
    mount.appendChild(formSection);
  }

  function init() {
    relocateForm();
    initProgress();
    initReveal();
    initHeroStagger();
    initCounters();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
